import { RootState } from 'app/store';

export const selectOpenSettings = (state: RootState) => state.settings.openSettings;

export const selectUserSettings = (state: RootState) => state.settings.userSettings;

export const selectLocale = (state: RootState) => state.settings.locale;

export const selectMeasurementTypeSettings = (state: RootState) => state.settings.systemOfMeasurement;

export const selectDateFormat = (state: RootState) => state.settings.dateFormat;
